import { NgModule } from '@angular/core';
import {
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HomeComponent } from './home/home.component';
import { ClaimsComponent } from './claims/claims.component';
import { LogoutComponent } from './logout/logout.component';
import { AccountService } from './shared/account/account.service';
import { LocalStorageService } from './shared/local-storage/local-storage.service';
import {
  InteractionType,
  IPublicClientApplication,
  PublicClientApplication,
} from '@azure/msal-browser';
import {
  loginRequest,
  msalConfig,
} from './auth.config';
import {
  MsalGuard,
  MsalGuardConfiguration,
  MsalModule,
  MsalService,
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
} from '@azure/msal-angular';
import { CustomRedirectComponent } from './custom.redirect'

export function MSALInstanceFactory(): IPublicClientApplication {
  var msalInstance =  new PublicClientApplication(msalConfig);
  msalInstance.initialize();
  msalInstance.enableAccountStorageEvents();
  return msalInstance;
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: loginRequest,
    loginFailedRoute: '/',
  };
}

@NgModule({ declarations: [
        AppComponent,
        HomeComponent,
        ClaimsComponent,
        LogoutComponent,
    ],
    bootstrap: [AppComponent, CustomRedirectComponent], imports: [BrowserModule,
        AppRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        MsalModule], providers: [
        {
            provide: MSAL_INSTANCE,
            useFactory: MSALInstanceFactory
        },
        {
            provide: MSAL_GUARD_CONFIG,
            useFactory: MSALGuardConfigFactory
        },
        AccountService,
        LocalStorageService,
        MsalGuard,
        MsalService,
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule {}
